var config = require('@sb/config')

// isV4 tells whether the website is using widget version 4.1 or not
function isV4_1 () {
	var scripts = document.getElementsByTagName('script')
	if (!(window._sbzq instanceof Array)) return false

	for (let s of scripts) {
		if (!s || !s.src) continue
		if (s.src.indexOf(config.BaseURL) !== -1) return true
		if (s.src.indexOf('https://widgetv4.subiz.com') !== -1) return true // old
	}
	return false
}

// isV4 tells whether the website is using widget version 4.2 or not
function isV4_2 () {
	if (window.sbz_v4) return true
	var scripts = document.getElementsByTagName('script')
	if (typeof window.subiz !== 'function') return false

	for (let s of scripts) {
		if (!s || !s.src) continue
		if (s.src.indexOf(config.BaseURL) !== -1) return true
		if (s.src.indexOf('https://widgetv4.subiz.com') !== -1) return true
		if (s.src.indexOf('https://widget.mysubiz.com') !== -1) return true
		if (s.src.indexOf('https://storage.googleapis.com/sbz') !== -1) return true
	}
	return false
}

function isV4_3 () {
	return !!window._sbzaccid
}

// isV2 tells whether the website is using widget version 2 or not
function isV2 () {
	if (!window._sbzq) return false
	var scripts = document.getElementsByTagName('script')
	for (let s of scripts) {
		if (!s || !s.src) continue
		if (s.src.indexOf('static.subiz.com') !== -1) return true
	}
	return false
}

// return widget version
module.exports = () => {
	if (isV4_3()) return '4.3'
	if (isV4_2()) return '4.2'
	if (window.subiz_account_id && window.subiz_account_id > 0) return '1'
	if (isV4_1()) return '4.1'
	if (isV2()) return '2'

	return undefined
}
